<div class="container-fluid-modal">
 <div class="InvoiceHeader">
        <h2 mat-dialog-title>Product Movement</h2>

        <div class="headerButton">
            <!-- <button type="button" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Confirm
            </button> -->
            <button  *ngIf="rfidUpdatePermission === true"  class="btn btn-success btn-sm" mat-raised-button
                        (click)="acceptDialog(updateData)"><i class="fa fa-pencil-square-o"
                                                               aria-hidden="true"></i>ACCEPT
                </button>
                <button *ngIf="rfidUpdatePermission === true"  class="btn btn-danger btn-sm"
                        (click)="rejectDialog(rejectData)"><i class="fa fa-trash" aria-hidden="true"></i>REJECT
                </button>

            <button type="button" class="btn btn-warning btn-sm ng-star-inserted"  mat-raised-button (click)="close()"><i class="fa fa-times"
                    aria-hidden="true"></i> Close
            </button>
        </div>
    </div>

    <div class="invoiceWrapper">
        <div class="row">
            <div class="col-lg-1"> </div>
            <div class="col-lg-10">
                <div class="card">
                    <div class="card-body">


 			<table class="table table-bordered">
				<tbody>
<!--
                               <tr rowspan="" style="height: 20px;">
                                    <th  class="col1" scope="col">Body Part</th>
                                    <td class="col11"> {{displacementData.body_part_name}}</td>

                                </tr>
                                <tr rowspan="" style="height: 20px;">
                                    <td  class="col1" scope="col">Implant Name</td>
                                    <td class="col11"> {{displacementData.implant_name}}</td>
                                </tr>
-->
                                <tr rowspan="" style="height: 20px;">
                                    <th  class="col1" scope="col">Product Name</th>
                                    <td class="col11"> {{displacementHeader.product}}</td>
                                </tr>
				<tr rowspan="" style="height: 20px;">
                                    <th  class="col1" scope="col">Product Code</th>
                                    <td class="col11"> {{displacementHeader.product_code}}</td>
                                </tr>
				<tr rowspan="" style="height: 20px;">
                                    <td  class="col1" scope="col">Batch Number</td>
                                    <td class="col11"> {{displacementHeader.batch_no}}</td>
                                </tr>
				<tr rowspan="" style="height: 20px;">
                                    <td  class="col1" scope="col">Expiry Date</td>
                                    <td class="col11"> {{displacementHeader.expire_date}}</td>
                                </tr>
				<tr rowspan="" style="height: 20px;">
                                    <td c class="col1" scope="col">Tracking Number</td>
                                    <td class="col11"> {{displacementHeader.trackingId}}    </td>
                                </tr>
				<tr  style="height: 20px;">
                                    <td   colspan="2" class="col10">Displacement Deatils  {{updateRFID}} </td>
                                    
                                </tr>



				<tr rowspan="" style="height: 50px;">
                                    <td class="col10">
                                      <div class="timeline"> 
					<div  *ngFor="let time of displacementData">
                                          <div class="content1">
                                           <h4>{{time.date_displacement}}</h4>
                                           <p>{{time.location_name}} - {{time.store_name}} {{time.name}} {{time.code}} <span *ngIf="time.current_status === 'Closed'">  (Used)</span></p>
                                         </div>
					<br>
					</div>
                                      </div>
				     </td>
                                    <td class="col11" style="height: 50px;"> 
					 <div class="header-logo" >
      					 <img src="{{ImgName}}" >
    					 </div>
				    </td>
                                </tr>
                            </tbody>
			</table>

		</div>
	     </div>
	 </div>
   	</div>
       </div>
   </div>

